import { Line, } from 'vue-chartjs'
import {mapState} from "vuex";
import moment from "moment";
export default {
    extends: Line,
    mounted () {
        let days = [];
        let success_amounts = [];
        let failed_amounts = [];
        let pending_amounts = [];

        for (let index in this.datas.last_30_days_success_transaction){
            let data = this.datas.last_30_days_success_transaction[index];
            let status = data.status[0];
            let date = new moment(new Date(data._id)).format('D/MM/Y');
            days.push(date);
            switch (status) {
                case process.env.VUE_APP_STATUS_SUCCESS:
                    pending_amounts.push(0);
                    failed_amounts.push(0);
                    success_amounts.push(data.totalAmount);
                    break;
                case process.env.VUE_APP_STATUS_PENDING:
                    pending_amounts.push(data.totalAmount);
                    failed_amounts.push(0);
                    success_amounts.push(0);
                    break;
                case process.env.VUE_APP_STATUS_ERROR:
                    pending_amounts.push(0);
                    failed_amounts.push(data.totalAmount);
                    success_amounts.push(0);
                    break;
                default:
                    break;
            }

        }

        this.renderChart({
            labels: days,
            datasets: [
                {
                    label: 'Transaction effectué',
                    backgroundColor: "#29B3A6",
                    data: success_amounts,
                    fill:false,
                    borderColor:'#29B3A6',
                },
                {
                    label: 'Transactions en attente',
                    backgroundColor: '#f0ad4e',
                    data: pending_amounts,
                    fill:false,
                    borderColor:'#f0ad4e',

                },
                {
                    label: 'Transactions  échouées',
                    backgroundColor: '#b71c1c',
                    data: failed_amounts,
                    fill:false,
                    borderColor:'#b71c1c',
                }
            ]
        }, {responsive: true, maintainAspectRatio: false})
    },
    computed:{
        ...mapState('dashboard',['datas']),

    }
}
